// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles--wrapper--2rT1f","iconWarning":"styles--iconWarning--3_URP","iconInfo":"styles--iconInfo--uI5l7"};